/**
 * 从requst中获取文件名（确保请求中有filename这个参数）
 * @param {*} request
 * @param {*} url
 */
function pGetFileName(request, url) {
  var disposition = request.getResponseHeader("Content-Disposition");
  var filename = "";
  if (disposition) {
    var matchs = pGetParamName(disposition, "filename=");
    if (matchs) {
      filename = decodeURIComponent(matchs);
    } else {
      filename = "petro" + Date.getTime();
    }
  } else {
    filename = url.substring(url.lastIndexOf("/") + 1);
    filename = filename.split("?")[0];
  }
  return filename;
}

/**
 * WPS下载文件到本地打开（业务系统可根据实际情况进行修改）
 * @param {*} url 文件流的下载路径
 * @param {*} callback 下载后的回调
 * @param {*} fileName 自定义文件名称
 * @param {*} isDelete 操作完成后，是否删除本地文件
 */
function DownloadFile(url, callback, fileName, isDelete) {
  var xhr = new XMLHttpRequest();
  xhr.onreadystatechange = function() {
    if (this.readyState == 4 && this.status == 200) {
      //需要业务系统的服务端在传递文件流时，确保请求中的参数有filename
      fileName = fileName ? fileName : pGetFileName(xhr, url);
      //落地打开模式下，WPS会将文件下载到本地的临时目录，在关闭后会进行清理
      // var path = wps.Env.GetTempPath() + "/" + fileName;
      var path = "C:/Users/yewen/Desktop" + "/" + fileName;
      wps.FileSystem.Remove(path);
      var reader = new FileReader();
      reader.onload = function() {
        wps.FileSystem.writeAsBinaryString(path, reader.result);
        callback(path);
        isDelete && wps.FileSystem.Remove(path);
      };
      reader.readAsBinaryString(xhr.response);
    }
  };
  xhr.open("GET", url);
  xhr.responseType = "blob";
  xhr.send();
}

// 去重并记录重复次数
function arrayReduce(array, name) {
  let data = [];
  let hash = {};
  data = array.reduce((item, next) => {
    const key = next[name];
    if (hash[key]) {
      item = item.map((c) => {
        if (c[name] === key) {
          return {
            ...c,
            appearTotal: c.appearTotal + 1,
          };
        }
        return c;
      });
    } else {
      hash[key] = 1;
      item.push({
        ...next,
        appearTotal: hash[key],
      });
    }
    return item;
  }, []);
  return data;
}

// 文字选中时的BG或color
function addTextSelectionColor(item) {
  const { start, end, errorTypeName } = item;

  const textStyle = JSON.parse(localStorage.getItem("textStyle"));

  wps.PluginStorage.setItem("isUpdateDialog", false);
  wps.Application.Selection.SetRange(start, end);
  const action = wps.Application.ActiveDocument.Range(start, end);
  // const action = wps.Application.ActiveDocument.ActiveWindow.Selection.Range;
  wps.Application.ActiveDocument.ActiveWindow.Selection.Range.Select();

  let id = 6;
  if (errorTypeName === "错词") {
    id = textStyle.error;
  }
  if (errorTypeName === "疑问词") {
    id = textStyle.warning;
  }
  if (errorTypeName === "敏感词") {
    id = textStyle.sensitive;
  }

  if (textStyle && textStyle.type == "font") {
    action.Font.ColorIndex = id;
  } else {
    action.HighlightColorIndex = id;
  }
  wps.PluginStorage.setItem("isUpdateDialog", true);
}

function confidenceName(item) {
  const { confidence, type } = item;
  if (type.indexOf("敏感词") >= 0) {
    return "敏感词";
  }
  if (confidence > 0.85) {
    return "错词";
  } else if (confidence < 0.85 && confidence > 0.6) {
    return "疑问词";
  }
  return confidence;
}

export { DownloadFile, arrayReduce, addTextSelectionColor, confidenceName };
